import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { navLinks, logoUrl } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo - Made Bigger */}
          <a href="#hero" className="flex-shrink-0">
            <img
              src={logoUrl}
              alt="Kip Energy"
              className="h-16 lg:h-20 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                  isScrolled
                    ? 'text-slate-700 hover:text-orange-500 hover:bg-orange-50'
                    : 'text-slate-800 hover:text-orange-500 hover:bg-white/20'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA with Contact Info */}
          <div className="hidden lg:flex flex-col items-end gap-2">
            {/* Buttons */}
            <div className="flex items-center space-x-3">
              <Button
                variant="outline"
                className="border-orange-500 text-orange-500 hover:bg-orange-50"
                asChild
              >
                <a href="#stations">Trouver une Station</a>
              </Button>
              <Button
                className="bg-orange-500 hover:bg-orange-600 text-white"
                asChild
              >
                <a href="#stations">Devenir Partenaire</a>
              </Button>
            </div>
            
            {/* Contact Info */}
            <div className="flex items-center gap-4 text-xs">
              <a 
                href="tel:+2252722412525" 
                className="flex items-center gap-1.5 text-slate-600 hover:text-orange-500 transition-colors"
              >
                <Phone className="w-3 h-3" />
                <span>27 22 41 25 25</span>
              </a>
              <a 
                href="mailto:contact@kipenergy.ci" 
                className="flex items-center gap-1.5 text-slate-600 hover:text-orange-500 transition-colors"
              >
                <Mail className="w-3 h-3" />
                <span>contact@kipenergy.ci</span>
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-slate-700" />
            ) : (
              <Menu className="w-6 h-6 text-slate-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-slate-100 py-4 animate-in slide-in-from-top-2">
            <nav className="flex flex-col space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="px-4 py-3 text-slate-700 hover:text-orange-500 hover:bg-orange-50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              
              {/* Mobile Contact Info */}
              <div className="px-4 py-3 border-t border-slate-100 mt-2 pt-4">
                <div className="flex flex-col gap-2 text-sm">
                  <a 
                    href="tel:+2252722412525" 
                    className="flex items-center gap-2 text-slate-600"
                  >
                    <Phone className="w-4 h-4 text-orange-500" />
                    <span>27 22 41 25 25</span>
                  </a>
                  <a 
                    href="mailto:contact@kipenergy.ci" 
                    className="flex items-center gap-2 text-slate-600"
                  >
                    <Mail className="w-4 h-4 text-orange-500" />
                    <span>contact@kipenergy.ci</span>
                  </a>
                </div>
              </div>
              
              <div className="pt-4 px-4 space-y-2">
                <Button
                  variant="outline"
                  className="w-full border-orange-500 text-orange-500 hover:bg-orange-50"
                  asChild
                >
                  <a href="#stations">Trouver une Station</a>
                </Button>
                <Button
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white"
                  asChild
                >
                  <a href="#stations">Devenir Partenaire</a>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
